import React from "react";
import CategoriasModule from "./CategoriasModule";

export default function DescuentosFamiliares() {
  return <CategoriasModule section="descuentos" />;
}
